// extracted by mini-css-extract-plugin
export default {"padding-x":"20","container":"tableSorted_container__l7+vK"};